import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { colors } from "../../../styles";
import { forceLogout } from "../../../utils";
import MyIcon from "../../Icon/MyIcon";

export default function SideBar() {

    ////////////////////////////////////////////////////////////////////// 메뉴 클릭 시 상태 변경

    const [isAnalysisAccordionOpen, setIsAnalysisAccordionOpen] = useState(false);
    const [isUserAccordionOpen, setIsUserAccordionOpen] = useState(false);
    const [isChatAccordionOpen, setIsChatAccordionOpen] = useState(false);
    const [isKeywordAccordionOpen, setIsKeywordAccordionOpen] = useState(false);

    return (
        <VStack 
            backgroundColor={colors.g5} 
            color={colors.black} 

            width={250} 
            height={"100vh"}

            padding={5}

            justifyContent={"space-between"}
            alignItems={"flex-start"}
            
            overflowY="auto"
        >
            <VStack
                gap={8}
                alignItems={"flex-start"}
            >

                {/* 로고 */}

                <Image src={"/png/logo.png"} alt="logo" width={135} height={45} objectFit={"contain"} />

                {/* 메인 */}

                <Link to={"main"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/radio-solid.svg"} alt="home" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>메인</Text>
                    </HStack>
                </Link>

                {/* 분석 */}

                <Box as="button" onClick={() => setIsAnalysisAccordionOpen(!isAnalysisAccordionOpen)}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        {isAnalysisAccordionOpen ? <MyIcon src={"/svg/arrow-down.svg"} alt="arrow-down" width={24} height={24} /> : <MyIcon src={"/svg/arrow-right.svg"} alt="arrow-right" width={24} height={24} />}
                        <Text fontSize={16} fontWeight={500}>분석</Text>
                    </HStack>
                </Box>

                {isAnalysisAccordionOpen && (
                    <VStack 
                        gap={8}
                        paddingLeft={3}
                        alignItems={"flex-start"}
                    >
                        <Link to={"analysis/search"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/search.svg"} alt="search" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>검색 분석</Text>
                            </HStack>
                        </Link>

                        {/* 검색 로그 */}

                        <Link to={"analysis/search-logs"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/file-text.svg"} alt="search" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>검색 로그</Text>
                            </HStack>
                        </Link>
                        <Link to={"analysis/entry"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/capsule-filled.svg"} alt="product" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>제품 분석</Text>
                            </HStack>
                        </Link>
                        <Link to={"analysis/entry-logs"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/file-text.svg"} alt="product" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>진입 로그</Text>
                            </HStack>
                        </Link>
                        <Link to={"analysis/chat"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/messenger-filled.svg"} alt="chat" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>채팅 분석</Text>
                            </HStack>
                        </Link>
                        <Link to={"analysis/trend"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/packages.svg"} alt="trend" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>추이 분석</Text>
                            </HStack>
                        </Link>
                    </VStack>
                )}

                {/* 유저 */}

                <Box as="button" onClick={() => setIsUserAccordionOpen(!isUserAccordionOpen)}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        {isUserAccordionOpen ? <MyIcon src={"/svg/arrow-down.svg"} alt="arrow-down" width={24} height={24} /> : <MyIcon src={"/svg/arrow-right.svg"} alt="arrow-right" width={24} height={24} />}
                        <Text fontSize={16} fontWeight={500}>유저</Text>
                    </HStack>
                </Box>

                {isUserAccordionOpen && (
                
                    <VStack 
                        gap={8}
                        paddingLeft={3}

                        alignItems={"flex-start"}
                    >

                        {/* 통합 유저 */}

                        <Link to={"users"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <Text> 🧑🏻 </Text>
                                <Text fontSize={16} fontWeight={500}>회원</Text>
                            </HStack>
                        </Link>

                         {/* 게스트 */}

                         <Link to={"guests"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <Text> 🧑🏻 </Text>
                                <Text fontSize={16} fontWeight={500}>게스트</Text>
                            </HStack>
                        </Link>

                    </VStack>
                )}

                <Box as="button" onClick={() => setIsChatAccordionOpen(!isChatAccordionOpen)}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        {isChatAccordionOpen ? <MyIcon src={"/svg/arrow-down.svg"} alt="arrow-down" width={24} height={24} /> : <MyIcon src={"/svg/arrow-right.svg"} alt="arrow-right" width={24} height={24} />}
                        <Text fontSize={16} fontWeight={500}>팜챗</Text>
                    </HStack>
                </Box>

                {isChatAccordionOpen && (

                    <VStack 
                        gap={8}
                        paddingLeft={3}

                        alignItems={"flex-start"}
                    >

                        {/* 프로필 */}

                        <Link to={"profiles"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/callbook-line-g1.svg"} alt="chat" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>프로필</Text>
                            </HStack>
                        </Link>

                        {/* 채팅 */}

                        <Link to={"chats"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/messenger-filled.svg"} alt="chat" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>채팅</Text>
                            </HStack>
                        </Link>

                        {/* 댓글 */}

                        <Link to={"comments"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/message-circle.svg"} alt="chat" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>댓글</Text>
                            </HStack>
                        </Link>

                        {/* 답글 */}

                        <Link to={"replies"}>   
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                <MyIcon src={"/svg/message-circle.svg"} alt="chat" width={24} height={24} />
                                <Text fontSize={16} fontWeight={500}>답글</Text>
                            </HStack>
                        </Link>

                    </VStack>
                )}

                {/* 약국 */}

                <Link to={"pharmacies"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/pharm-filled.svg"} alt="user" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>약국</Text>
                    </HStack>
                </Link>

                {/* 회사 */}

                <Link to={"companies"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/store.svg"} alt="company" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>제약사</Text>
                    </HStack>
                </Link>

                {/* 약 */}
                
                <Link to={"medicines"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/capsule-filled.svg"} alt="user" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>약</Text>
                    </HStack>
                </Link>

                {/* 재료 */}

                <Link to={"ingredients"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/moneybag.svg"} alt="user" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>성분</Text>
                    </HStack>
                </Link>

                {/* meilisearch */}

                <Link to={"meilisearch"}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        <MyIcon src={"/svg/filter-2.svg"} alt="fliter" width={24} height={24} />
                        <Text fontSize={16} fontWeight={500}>검색 설정</Text>
                    </HStack>
                </Link>

                {/* 키워드 */}

                <Box as="button" onClick={() => setIsKeywordAccordionOpen(!isKeywordAccordionOpen)}>
                    <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                        {isKeywordAccordionOpen ? <MyIcon src={"/svg/arrow-down.svg"} alt="arrow-down" width={24} height={24} /> : <MyIcon src={"/svg/arrow-right.svg"} alt="arrow-right" width={24} height={24} />}
                        <Text fontSize={16} fontWeight={500}>키워드</Text>
                    </HStack>
                </Box>

                {isKeywordAccordionOpen && (
                
                    <VStack 
                        gap={8}
                        paddingLeft={3}

                        alignItems={"flex-start"}
                    >
                        <Link to={"keywords-by-keyword"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                {/* <MyIcon src={"/svg/arrow-right.svg"} alt="keyword" width={24} height={24} /> */}
                                <Text>🔑</Text>
                                <Text fontSize={16} fontWeight={500}>키워드로 검색</Text>
                            </HStack>
                        </Link>
                        <Link to={"keywords-by-medicine"}>
                            <HStack justifyContent={"flex-start"} alignItems={"center"} gap={3}>
                                {/* <MyIcon src={"/svg/arrow-right.svg"} alt="keyword" width={24} height={24} /> */}
                                <Text>💊</Text>
                                <Text fontSize={16} fontWeight={500}>약품으로 검색</Text>
                            </HStack>
                        </Link>
                    </VStack>

                )}
            </VStack>
            <Button
                variant={"ghost"}
                color={colors.g3}
                _hover={{ backgroundColor: colors.g3, color: colors.white }}
                onClick={forceLogout}
            >
                <Text fontSize={14} fontWeight={400}>로그아웃</Text>
            </Button>
        </VStack>
    )
}